export default function getRedditShareLink(title="",url="") {
  return "https://www.reddit.com/submit?url=" + encodeURIComponent(url) + "&title=" + encodeURIComponent(title)
}
